import React, { useState, useEffect } from "react";
import axios from "axios";
import $ from "jquery";
import moment from "moment";
import * as XLSX from "xlsx";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import swal from "sweetalert";

const BookingBalc = (props) => {
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    clientName: "",
    phone: "",
    dateRange: "",
  });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [showClearButton, setShowClearButton] = useState(false);
  const [typevalue, settypevalue] = useState("");

  useEffect(() => {
    let isMounted = true;

    const fetchTableData = async () => {
      const url =
        process.env.REACT_APP_APIURL +
        "booking/GetALLBookingspay?companyid=" +
        props.companyid;
      try {
        const responseData = await axios.get(url);
        if (isMounted) {
          setOriginalData(responseData.data);
          setTableData(responseData.data);
          setLoading(false);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching table data:", error);
          setLoading(false);
        }
      }
    };

    fetchTableData();

    return () => {
      isMounted = false; // Cleanup function to set isMounted to false
    };
  }, [props.companyid]);

  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#example3")) {
      $("#example3").DataTable().destroy();
    }

    if (tableData.length > 0) {
      $("#example3").DataTable({
        ordering: true,
        order: [],
      });
    }
  }, [tableData]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleDateChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const applyFilters = () => {
    if ($.fn.DataTable.isDataTable("#example3")) {
      $("#example3").DataTable().destroy();
    }

    const filteredData = originalData.filter((row) => {
      const matchesClient = filters.clientName
        ? row.cusName?.toLowerCase().includes(filters.clientName.toLowerCase())
        : true;
      const matchesPhone = filters.phone
        ? row.phone
            ?.replace(/\s+/g, "")
            .includes(filters.phone.replace(/\s+/g, ""))
        : true;
      const matchesDateRange =
        startDate && endDate
          ? moment(row.bookingdate).isBetween(
              startDate,
              endDate,
              undefined,
              "[]"
            )
          : true;

      return matchesClient && matchesPhone && matchesDateRange;
    });

    if (filteredData.length === 0) {
      swal({
        title: "No Match Found!",
        text: "No data matches your filter criteria.",
        icon: "error",
      });
    }

    setTableData(filteredData);
    setShowClearButton(true);
  };

  const clearFilters = () => {
    setFilters({ clientName: "", phone: "", dateRange: "" });
    setStartDate(null);
    setEndDate(null);

    if ($.fn.DataTable.isDataTable("#example3")) {
      $("#example3").DataTable().destroy();
    }

    setTableData(originalData);
    setShowClearButton(false);
  };

  const exportToExcel = () => {
    const exportData = tableData.map((row) => ({
      "Client Name": row.cusName || "--",
      "Phone No.": row.phone
        ? row.phone.replace(/(\d{4})(\d{7})/, "$1 $2")
        : "N/A",
      "Booking Type": (() => {
        if (row.type === 1) return "Corporate";
        if (row.type === 2) return "Family";
        if (row.type === 3) return "Edu. Institute";
        if (row.type === 4) return "School";
        if (row.type === 5) return "Friend";
        return "--";
      })(),
      "No Of Members": row.noOfMembers || "--",
      "Booking Date": moment(row.bookingdate).format("dddd, MMM DD, YYYY") || "--",
      Unit: row.unitName || "--",
      Shift: row.shiftName || "--",
      "Original Amount": row.samount || "--",
      "Discount": row.discount || "--",
      "Final Amount": (row.samount ?? 0) - (row.discount ?? 0) || 0,
      "Paid Amount":
        (row.adv ?? 0) +
        (row.pay2 ?? 0) +
        (row.pay3 ?? 0) +
        (row.pay4 ?? 0) +
        (row.pay5 ?? 0),
      "Balance Amount":
        (row.samount ?? 0) -
        (row.discount ?? 0) -
        (row.adv ?? 0) -
        (row.pay2 ?? 0) -
        (row.pay3 ?? 0) -
        (row.pay4 ?? 0) -
        (row.pay5 ?? 0),
    }));

    // Calculate totals for each column
    const totals = {
      "Client Name": "Total",
      "Phone No.": "",
      "Booking Type": "",
      "No Of Members":"",
      "Booking Date": "",
      Unit: "",
      Shift: "",
      "Original Amount": tableData.reduce(
        (sum, row) => sum + (row.samount || 0),
        0
      ),
      "Discount": tableData.reduce(
        (sum, row) => sum + (parseFloat(row.discount) || 0),
        0
      ),
      "Final Amount": tableData.reduce(
        (sum, row) => sum + ((row.samount ?? 0) - (row.discount ?? 0)),
        0
      ),
      "Paid Amount": tableData.reduce(
        (sum, row) =>
          sum +
          (row.adv ?? 0) +
          (row.pay2 ?? 0) +
          (row.pay3 ?? 0) +
          (row.pay4 ?? 0) +
          (row.pay5 ?? 0),
        0
      ),
      "Balance Amount": tableData.reduce(
        (sum, row) =>
          sum +
          ((row.samount ?? 0) - (row.discount ?? 0) -
            (row.adv ?? 0) -
            (row.pay2 ?? 0) -
            (row.pay3 ?? 0) -
            (row.pay4 ?? 0) -
            (row.pay5 ?? 0)),
        0
      ),
    };

    const emptyRow = {
      "Client Name": "",
      "Phone No.": "",
      "Booking Type": "",
      "No Of Members": "",
      "Booking Date": "",
      Unit: "",
      Shift: "",
      "Original Amount": "",
      "Discount": "",
      "Final Amount": "",
      "Paid Amount": "",
      "Balance Amount": "",
    };

    exportData.push(emptyRow, totals);

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    worksheet["!cols"] = exportData[0]
      ? Object.keys(exportData[0]).map(() => ({ wch: 20 }))
      : [];
    Object.keys(worksheet).forEach((cell) => {
      if (cell[0] === "!") return;
      worksheet[cell].s = {
        alignment: { horizontal: "center", vertical: "center" },
        font: cell.match(/^[A-Z]+1$/) ? { bold: true } : {},
      };
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Booking Report");
    XLSX.writeFile(workbook, "BookingReport.xlsx");
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between">
              <h4 className="me-auto mb-0">Booking Bal Report</h4>
            </div>
            <div className="row align-items-center justify-content-between mb-3 pt-3 p-4">
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <label className="form-label">Search by Client Name</label>
                <input
                  type="text"
                  name="clientName"
                  value={filters.clientName}
                  onChange={handleFilterChange}
                  className="form-control"
                  placeholder="Search by Client Name"
                />
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <label className="form-label">Search by Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  value={filters.phone}
                  onChange={handleFilterChange}
                  className="form-control"
                  placeholder="Search by Phone No."
                />
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3 bal-rep">
                <label className="form-label">Date Range</label>
                <DateRangePicker
                  startDate={startDate}
                  startDateId="start_date_id"
                  endDate={endDate}
                  endDateId="end_date_id"
                  onDatesChange={handleDateChange}
                  focusedInput={focusedInput}
                  onFocusChange={(focusedInput) =>
                    setFocusedInput(focusedInput)
                  }
                  isOutsideRange={() => false}
                  numberOfMonths={1}
                  displayFormat="DD/MM/YYYY"
                />
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div className="d-flex justify-content-center mt-5 mb-3 gap-4">
                  <div>
                    <button className="btn btn-primary" onClick={applyFilters}>
                      Apply Filters
                    </button>
                  </div>
                  {showClearButton && (
                    <div>
                      <button
                        className="btn btn-secondary"
                        onClick={clearFilters}
                      >
                        Clear Filters
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Table */}
            <div className="card-body">
              {loading && (
                <section className="loader_main">
                  <span className="loader-5"></span>
                </section>
              )}
              <div className="table-responsive">
                <button
                  className="btn btn-success d-flex align-items-center mb-3"
                  onClick={exportToExcel}
                  style={{
                    backgroundColor: "#008236",
                    borderColor: "#008236",
                    color: "#fff",
                    padding: "10px 15px",
                    borderRadius: "5px",
                    fontWeight: "bold",
                  }}
                >
                  <i
                    className="fas fa-file-excel"
                    style={{ marginRight: "8px" }}
                  ></i>
                  Export to Excel
                </button>
                <table id="example3" className="display" data-page-length="10">
                  <thead>
                    <tr>
                      <th>Created On</th>
                      <th>BK#</th>
                      <th>Booked By</th>
                      <th>Enter By</th>
                      <th>Booking Date</th>
                      <th>Unit</th>
                      <th>Shift</th>
                      <th>No Of Members</th>
                      <th>Client Name</th>
                      <th>Phone No.</th>
                      <th>Booking type</th>
                      <th>Orignal Amount</th>
                      <th>Discount</th>
                      <th>Final Amount</th>
                      <th>ADV</th>
                      <th>DT.</th>
                      <th>PAY 2</th>
                      <th>Date 2</th>
                      <th>PAY 3</th>
                      <th>Date 3</th>
                      <th>PAY 4</th>
                      <th>Date 4</th>
                      <th>PAY 5</th>
                      <th>Date 5</th>
                      <th>BAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Map over your table data to render rows */}
                    {tableData.map((rowData, index) => (
                      <tr key={index}>
                        <td>
                          {moment(rowData.entrydate).format("MMM DD, YYYY") ||
                            "--"}
                        </td>
                        <td>{rowData.bookingId || "--"}</td>
                        <td>{rowData.bookedby || "--"}</td>
                        <td>{rowData.bookby || "--"}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {moment(rowData.bookingdate).format(
                            "dddd, MMM DD, YYYY"
                          ) || "--"}
                        </td>
                        <td>{rowData.unitName || "--"}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {rowData.shiftName}
                        </td>
                        <td>{rowData.noOfMembers || "--"}</td>
                        <td>{rowData.cusName || "--"}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {rowData.phone
                            ? rowData.phone.replace(/(\d{4})(\d{7})/, "$1 $2")
                            : "N/A" || "--"}
                        </td>
                        <td>
                          {(() => {
                            if (rowData.type === 1) return "Corporate";
                            if (rowData.type === 2) return "Family";
                            if (rowData.type === 3) return "Edu. Institute";
                            if (rowData.type === 4) return "School";
                            if (rowData.type === 5) return "Friend";
                            return "--";
                            })()}
                          </td>
                          <td style={{color:"orange"}}>{rowData.samount || "--"}</td>
                          <td style={{color:"red"}}>{rowData.discount || "--"}</td>
                          <td style={{color:"green"}}>{(rowData.samount ?? 0) - (rowData.discount ?? 0)}</td>
                          <td>{rowData.adv || "--"}</td>
                          <td>{rowData.pay1dt || "--"}</td>
                          <td>{rowData.pay2 || "--"}</td>
                          <td>{rowData.pay2dt || "--"}</td>
                          <td>{rowData.pay3 || "--"}</td>
                          <td>{rowData.pay3dt || "--"}</td>
                          <td>{rowData.pay4 || "--"}</td>
                          <td>{rowData.pay4dt || "--"}</td>
                          <td>{rowData.pay5 || "--"}</td>
                          <td>{rowData.pay5dt || "--"}</td>
                          {(() => {
                            const balance =
                              (rowData.samount ?? 0) -
                              (rowData.discount ?? 0) -
                              (rowData.adv ?? 0) -
                              (rowData.pay2 ?? 0) -
                              (rowData.pay3 ?? 0) -
                              (rowData.pay4 ?? 0) -
                              (rowData.pay5 ?? 0);
                            return (
                              <td style={{ color: balance === 0 ? "green" : "red" }}>
                              {balance}
                              </td>
                            );
                            })()}
                          </tr>
                        ))}
                        </tbody>
                      </table>
                      </div>
                    </div>
                    {/* Table */}
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingBalc;
